<template>
  <span class="flex items-baseline font-bold text-base whitespace-nowrap">
    {{ formattedAmount }}
  </span>
</template>
<script setup>
import { useUserStore } from "@/store/user.js";
import { formatCurrency } from "@xs2event/js-lib";
import { computed } from "vue";

const userStore = useUserStore();
const props = defineProps({
  amount: { default: 0 },
  calcFxRate: { default: false },
  originalCurrency: { default: null },
  netAmount: { default: null },
});

const formattedAmount = computed(() => {
  if (props.calcFxRate) {
    const fxAmount = userStore.calcFx(props.amount, props.originalCurrency, props.netAmount);
    return formatCurrency(fxAmount, userStore.selectedCurrency || "EUR");
  }
  return formatCurrency(props.amount, "EUR");
});
</script>
